import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SkeletonComponent } from './skeleton.component';
import { ImportsModule } from '../../../imports/imports';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ImportsModule,
    SkeletonComponent
  ],
  exports: [
    SkeletonComponent
  ]
})
export class SkeletonModule { }
